(function () {
    'use strict';

    angular.module("imApp").factory("travelBillMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1254,
                    parameters: parms || {}
                });
            },
            listTravelBills: function (parms) {
                return $ihttp.post({
                    method: 1257,
                    parameters: parms || {}
                });
            },
            sendIn: function (menu) {
                return $ihttp.post({
                    method: 1324,
                    parameters: menu
                });
            },
            approve: function (menu) {
                return $ihttp.post({
                    method: 1325,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
